import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { frameworkSteps, valueProps } from '../data/framework';
export function StrategicFramework() {
  return <section id="framework" className="bg-white py-24 lg:py-32" data-id="element-171" data-mp="1wqwi7sepe13x">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-172" data-mp="1rxberkuccexc">
        <SectionHeading eyebrow="06. Strategic Value Proposition" title="A Repeatable Framework for Enterprise Value" data-id="element-173" data-mp="25p83dewsw6oz" />

        <div className="mt-14 flex flex-wrap items-center justify-center gap-3 sm:gap-4 border border-slate-200 bg-slate-50 px-6 py-8" data-id="element-174" data-mp="20pvhoxho15nz">
          {frameworkSteps.map((step, index) => <React.Fragment key={step.label} data-id="element-175" data-mp="2apw62xue6bz1" data-mpi={index}>
              <div className="border border-navy/15 bg-white px-5 py-3 text-sm font-semibold text-navy whitespace-nowrap" data-id="element-176" data-mp="l9myd4rnx723">
                {step.label}
              </div>
              {index < frameworkSteps.length - 1 && <ArrowRightIcon className="h-4 w-4 text-gold shrink-0" strokeWidth={2} data-id="element-177" data-mp="2vjh27h8izc39" />}
            </React.Fragment>)}
        </div>

        <div className="mt-14 grid sm:grid-cols-3 gap-6" data-id="element-178" data-mp="2zig38qr4yopf">
          {valueProps.map((prop, index) => {
          const Icon = prop.icon;
          return <motion.div key={prop.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            ease: [0.23, 1, 0.32, 1],
            delay: index * 0.08
          }} className="border-t-2 border-gold pt-6" data-id="element-179" data-mp="39b40fmm12uoo" data-mpi={index}>
                <Icon className="h-6 w-6 text-gold-dark" strokeWidth={1.5} data-id="element-180" data-mp="3s9g9l8cxw4k9" />
                <h3 className="mt-4 font-serif text-lg font-semibold text-navy" data-id="element-181" data-mp="1swc8fassnpfw">{prop.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-182" data-mp="1xux89944w73t">{prop.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}